<template>
  <section class="uk-text-left container">
    <section class="section-titles">
      <h3 class="title">
        Selección de Componentes
      </h3>
      <p class="subtitle helper">
        Favor seleccionar cada una de los componentes que quiere considerar al
        correr el modelo de simulación.
      </p>
    </section>
    <div class="main">
      <form class="uk-form-stacked uk-margin">
        <div>
          <h5 v-if="transportMode === transportModeTypeEnum.maritime || dollyType === dollyTypeEnum.dryLoad || (transportMode === transportModeTypeEnum.aerial && directionTypeEnum.export === journeyDirection && dollyType === dollyTypeEnum.reefer)">
            Logística de Almacén
          </h5>
        </div>

        <div class="uk-column-1-2 uk-margin">
          <div
            v-if="journeyDirection === directionTypeEnum.export"
            @mouseover="setMessageInformation('Seleccione esta elemento para calcular la Logística de Envío')"
            @mouseleave="setMessageInformation()"
          >
            <label
              class="check-label"
              for="selectionShippingLogistics"
            >
              <input
                id="selectionShippingLogistics"
                v-model="selectionComponents.selectionShippingLogistics"
                class="check-label"
                type="checkbox"
                name="selectionShippingLogistics"
                @change="visibleWarehouseLogistics"
              >Logística de Envío
            </label>
          </div>

          <div
            v-if="journeyDirection === directionTypeEnum.import && (!(journeyDirection === directionTypeEnum.import && transportMode === transportModeTypeEnum.aerial && dollyType === dollyTypeEnum.reefer))"
            @mouseover="setMessageInformation('Seleccione esta elemento para calcular la Logística de Recepción')"
            @mouseleave="setMessageInformation()"
          >
            <label
              class="check-label"
              for="selectionReceptionLogistics "
            >
              <input
                id="selectionReceptionLogistics "
                v-model="selectionComponents.selectionReceptionLogistics "
                class="check-label"
                type="checkbox"
                name="selectionReceptionLogistics "
                @change="visibleWarehouseLogistics"
              >Logística de Recepción
            </label>
          </div>
          <div
            v-if="!((journeyDirection === directionTypeEnum.import && transportMode === transportModeTypeEnum.aerial && dollyType === dollyTypeEnum.reefer) || isFOB)"
            @mouseover="setMessageInformation('Seleccione esta elemento para calcular los Seguros y Extras')"
            @mouseleave="setMessageInformation()"
          >
            <label
              class="check-label"
              for="selectionInsuranceExtras"
            >
              <input
                id="selectionInsuranceExtras"
                v-model="selectionComponents.selectionInsuranceExtras"
                class="check-label"
                type="checkbox"
                name="selectionInsuranceExtras"
                @change="visibleWarehouseLogistics"
              >Seguros y Extras
            </label>
          </div>
        </div>

        <div>
          <h5>Transporte Interior</h5>
        </div>

        <div class="uk-column-1-2 uk-margin">
          <div
            v-if="journeyDirection === directionTypeEnum.export"
            @mouseover="setMessageInformation('Seleccione esta elemento para calcular el Transporte Interior')"
            @mouseleave="setMessageInformation()"
          >
            <label
              class="check-label"
              for="selectionInlandTransportation "
            >
              <input
                id="selectionInlandTransportation "
                v-model="selectionComponents.selectionInlandTransportation "
                class="check-label"
                type="checkbox"
                name="selectionInlandTransportation "
                @change="visibleInteriorTransport"
              >Transporte Interior
            </label>
          </div>
          <div
            v-if="journeyDirection === directionTypeEnum.import"
            @mouseover="setMessageInformation('Seleccione esta elemento para calcular el Transporte Interior')"
            @mouseleave="setMessageInformation()"
          >
            <label
              class="check-label"
              for="selectionInlandTransportationImport "
            >
              <input
                id="selectionInlandTransportationImport "
                v-model="selectionComponents.selectionInlandTransportationImport"
                class="check-label"
                type="checkbox"
                name="selectionInlandTransportationImport "
                @change="visibleInteriorTransport"
              >Transporte Interior
            </label>
          </div>
        </div>
        <div>
          <h5>Tramitación y Tasas</h5>
        </div>

        <div class="uk-column-1-2 uk-margin">
          <div
            v-if="journeyDirection === directionTypeEnum.export"
            @mouseover="setMessageInformation('Seleccione esta elemento para calcular los Gastos de Pre-Embarque')"
            @mouseleave="setMessageInformation()"
          >
            <label
              class="check-label"
              for="selectionManagementExpenses "
            >
              <input
                id="selectionManagementExpenses "
                v-model="selectionComponents.selectionManagementExpenses "
                class="check-label"
                type="checkbox"
                name="selectionManagementExpenses "
                @change="visibleProcessingAndFees"
              >Gastos de Pre-Embarque
            </label>
          </div>

          <div
            v-if="journeyDirection === directionTypeEnum.export"
            class="uk-margin"
            @mouseover="setMessageInformation('Seleccione esta elemento para calcular los Trámites y Permisos')"
            @mouseleave="setMessageInformation()"
          >
            <label
              class="check-label"
              for="selectionProceduresPermits"
            >
              <input
                id="selectionProceduresPermits"
                v-model="selectionComponents.selectionProceduresPermits"
                class="check-label"
                type="checkbox"
                name="selectionProceduresPermits"
                @change="visibleProcessingAndFees"
              >Trámites y Permisos
            </label>
          </div>

          <div
            class="uk-margin"
            @mouseover="setMessageInformation('Seleccione esta elemento para calcular los Trámites y Permisos')"
            @mouseleave="setMessageInformation()"
          >
            <label
              v-if="journeyDirection === directionTypeEnum.import"
              class="check-label"
              for="selectionCustomsClearanceImport"
            >
              <input
                id="selectionCustomsClearanceImport"
                v-model="selectionComponents.selectionCustomsClearanceImport"
                class="check-label"
                type="checkbox"
                name="selectionCustomsClearanceImport"
                @change="visibleProcessingAndFees"
              >Tramitación Aduanal
            </label>
          </div>

          <div
            v-if="journeyDirection === directionTypeEnum.export || (transportMode === transportModeTypeEnum.maritime && dollyType == dollyTypeEnum.dryLoad)"
            @mouseover="setMessageInformation('Seleccione esta elemento para calcular las Tasas e Inpuestos')"
            @mouseleave="setMessageInformation()"
          >
            <label
              class="check-label"
              for="selectRatesTaxes"
            >
              <input
                id="selectRatesTaxes"
                v-model="selectionComponents.selectRatesTaxes"
                class="check-label"
                type="checkbox"
                name="selectRatesTaxes"
                @change="visibleProcessingAndFees"
              >Tasas e Impuestos
            </label>
          </div>
        </div>

        <div>
          <h5>Flete Internacional</h5>
        </div>
        <div class="uk-column-1-2 uk-margin">
          <div
            v-if="transportMode === transportModeTypeEnum.maritime && journeyDirection === directionTypeEnum.export"
            @mouseover="setMessageInformation('Seleccione esta elemento para calcular la Gestión Terminal')"
            @mouseleave="setMessageInformation()"
          >
            <label
              class="check-label"
              for="selectTerminalManagement"
            >
              <input
                id="selectTerminalManagement"
                v-model="selectionComponents.selectTerminalManagement"
                class="check-label"
                type="checkbox"
                name="selectTerminalManagement"
                @change="visibleInternationalFreight"
              >Gestión Portuaria
            </label>
          </div>

          <div
            v-if="transportMode === transportModeTypeEnum.maritime && journeyDirection === directionTypeEnum.import"
            class="uk-margin"
            @mouseover="setMessageInformation('Seleccione esta elemento para calcular la Gestión Terminal')"
            @mouseleave="setMessageInformation()"
          >
            <label
              class="check-label"
              for="selectTerminalManagementImport"
            >
              <input
                id="selectTerminalManagementImport"
                v-model="selectionComponents.selectTerminalManagementImport"
                class="check-label"
                type="checkbox"
                name="selectTerminalManagementImport"
                @change="visibleInternationalFreight"
              >Gestión Portuaria
            </label>
          </div>

          <div
            v-if="transportMode === transportModeTypeEnum.aerial && journeyDirection === directionTypeEnum.export"
            class="uk-margin"
            @mouseover="setMessageInformation('Seleccione esta elemento para calcular la Gestión aeroportuaria')"
            @mouseleave="setMessageInformation()"
          >
            <label
              class="check-label"
              for="selectAirportManagement"
            >
              <input
                id="selectAirportManagement"
                v-model="selectionComponents.selectAirportManagement"
                class="check-label"
                type="checkbox"
                name="selectAirportManagement"
                @change="visibleInternationalFreight"
              >Gestión Aeroportuaria
            </label>
          </div>

          <div
            v-if="transportMode === transportModeTypeEnum.aerial && journeyDirection === directionTypeEnum.import"
            class="uk-margin"
            @mouseover="setMessageInformation('Seleccione esta elemento para calcular la Gestión aeroportuaria')"
            @mouseleave="setMessageInformation()"
          >
            <label
              class="check-label"
              for="selectAirportManagementImport"
            >
              <input
                id="selectAirportManagementImport"
                v-model="selectionComponents.selectAirportManagementImport"
                class="check-label"
                type="checkbox"
                name="selectAirportManagementImport"
                @change="visibleInternationalFreight"
              >Gestión Aeroportuaria
            </label>
          </div>
        </div>
      </form>
    </div>
    <div class="btn">
      <wizard-button :data="selectionIsValid" />
    </div>
  </section>
</template>

<script>
import { ComponentEnum } from '../../../enums'
import { mapGetters } from 'vuex'
import { directionTypeEnum, transportModeTypeEnum, dollyTypeEnum, incotermsEnum } from '../../../types'

export default {
  data () {
    return {
      directionTypeEnum,
      transportModeTypeEnum,
      dollyTypeEnum,
      incotermsEnum,

      conditionDirection: null,

      selectionComponents: {
        selectionShippingLogistics: null,
        selectionInsuranceExtras: null,
        selectionInsuranceExtrasImport: null,
        selectionReceptionLogistics: null,
        selectionFinancialCosts: null,
        selectionFinancialCostsImport: null,
        selectionInlandTransportation: null,
        selectionInlandTransportationImport: null,
        selectionManagementExpenses: null,
        selectionProceduresPermits: null,
        selectionCustomsClearanceImport: null,
        selectRatesTaxes: null,
        selectTerminalManagement: null,
        selectTerminalManagementImport: null,
        selectAirportManagement: null,
        selectAirportManagementImport: null,
        selectionInternationalTransport: null
      },
      informationMsg: {
        image: null,
        message: null
      }
    }
  },
  computed: {
    ...mapGetters([
      'journeyDirection',
      'transportMode',
      'dollyType',
      'storeSelectionComponents',
      'incoterm'
    ]),
    isFOB: function () {
      const incotermValue = this.incotermsEnum.find(inco => inco.text === 'FOB FREE ON BOARD')
      return this.incoterm.id === incotermValue?.value?.id
    },
    selectionIsValid () {
      return {
        isValid:
          this.selectionComponents.selectionShippingLogistics ||
          this.selectionComponents.selectionInsuranceExtras ||
          this.selectionComponents.selectionInsuranceExtrasImport ||
          this.selectionComponents.selectionReceptionLogistics ||
          this.selectionComponents.selectionFinancialCosts ||
          this.selectionComponents.selectionFinancialCostsImport ||
          this.selectionComponents.selectionInlandTransportation ||
          this.selectionComponents.selectionInlandTransportationImport ||
          this.selectionComponents.selectionManagementExpenses ||
          this.selectionComponents.selectionProceduresPermits ||
          this.selectionComponents.selectionCustomsClearanceImport ||
          this.selectionComponents.selectRatesTaxes ||
          this.selectionComponents.selectTerminalManagement ||
          this.selectionComponents.selectTerminalManagementImport ||
          this.selectionComponents.selectAirportManagement ||
          this.selectionComponents.selectAirportManagementImport ||
          this.selectionComponents.selectionInternationalTransport
      }
    }
  },
  watch: {
    selectionComponents: {
      handler: function (newVal) {
        this.$store.commit('setSelectionComponent', newVal)
      },
      deep: true
    }
  },
  mounted () {
    this.selectionComponents = { ...this.storeSelectionComponents }
    if (this.journeyDirection === directionTypeEnum.export) {
      this.conditionDirection = 1
    } else {
      this.conditionDirection = 2
    }
  },
  methods: {
    setMessageInformation (message, image) {
      this.informationMsg.image = image
      this.informationMsg.message = message

      this.$store.commit('setMessageInformation', this.informationMsg)
    },

    visibleWarehouseLogistics () {
      if (this.selectionComponents.selectionShippingLogistics) {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.ShippingLogistics, status: true }])
      } else {
        this.$store.commit('setResetShippingLogistic')
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.ShippingLogistics, status: false }])
      }
      if (this.selectionComponents.selectionReceptionLogistics) {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.ReceptionLogistics, status: true }])
      } else {
        this.$store.commit('setResetReceptionLogistics')
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.ReceptionLogistics, status: false }])
      }
      if (this.selectionComponents.selectionInsuranceExtras) {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.InsuranceAndExtras, status: true }])
      } else {
        this.$store.commit('setResetInsuranceAndExtras')
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.InsuranceAndExtras, status: false }])
      }
      if (this.selectionComponents.selectionFinancialCosts) {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.FinancialAdministrativeCosts, status: true }])
      } else {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.FinancialAdministrativeCosts, status: false }])
      }

      if (this.selectionComponents.selectionFinancialCostsImport) {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.FinancialAdministrativeCostsImport, status: true }])
      } else {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.FinancialAdministrativeCostsImport, status: false }])
      }

      if (this.selectionComponents.selectionShippingLogistics === true || this.selectionComponents.selectionReceptionLogistics === true || this.selectionComponents.selectionInsuranceExtras === true || this.selectionComponents.selectionFinancialCosts === true) {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.WarehouseLogistics, status: true }])
      } else {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.WarehouseLogistics, status: false }])
      }
    },
    visibleInteriorTransport () {
      if (this.selectionComponents.selectionInlandTransportation) {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.InlandTransportationParent, status: true }])
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.InlandTransportation, status: true }])
      } else {
        this.$store.commit('setResetInlandTransportation')
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.InlandTransportationParent, status: false }])
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.InlandTransportation, status: false }])
      }

      if (this.selectionComponents.selectionInlandTransportationImport) {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.InlandTransportationParent, status: true }])
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.InlandTransportationImport, status: true }])
      } else {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.InlandTransportationParent, status: false }])
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.InlandTransportationImport, status: false }])
      }
    },
    visibleProcessingAndFees () {
      if (this.selectionComponents.selectionManagementExpenses) {
        this.$store.commit('setCleaningFee', true)
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.AdministrationFees, status: true }])
      } else {
        this.$store.commit('setResetAdministrationFees')
        this.$store.commit('setCleaningFee', null)
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.AdministrationFees, status: false }])
      }
      if (this.selectionComponents.selectionProceduresPermits) {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.ProceduresAndPermits, status: true }])
      } else {
        this.$store.commit('setResetProceduresAndPermits')
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.ProceduresAndPermits, status: false }])
      }

      if (this.selectionComponents.selectionCustomsClearanceImport) {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.CustomClearanceImport, status: true }])
      } else {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.CustomClearanceImport, status: false }])
      }

      if (this.selectionComponents.selectRatesTaxes) {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.TaxesAndFees, status: true }])
      } else {
        this.$store.commit('setResetTaxesAndFees')
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.TaxesAndFees, status: false }])
      }

      if (this.selectionComponents.selectionManagementExpenses === true || this.selectionComponents.selectionProceduresPermits === true || this.selectionComponents.selectRatesTaxes === true) {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.ProcessingAndFees, status: true }])
      } else {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.ProcessingAndFees, status: false }])
      }
    },
    visibleInternationalFreight () {
      if (this.selectionComponents.selectTerminalManagement) {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.TerminalManagement, status: true }])
      } else {
        this.$store.commit('setResetTerminalManagement')
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.TerminalManagement, status: false }])
      }
      if (this.selectionComponents.selectTerminalManagementImport) {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.TerminalManagementImport, status: true }])
      } else {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.TerminalManagementImport, status: false }])
      }

      if (this.selectionComponents.selectionInternationalTransport) {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.InternationalTransport, status: true }])
      } else {
        this.$store.commit('setResetInternationalTransport')
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.InternationalTransport, status: false }])
      }

      if (this.selectionComponents.selectAirportManagement) {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.AirportManagement, status: true }])
      } else {
        this.$store.commit('setResetAirportManagement')
        if (this.transportMode === this.transportModeTypeEnum.aerial && this.journeyDirection === this.directionTypeEnum.export) {
          this.$store.commit('setResetShippingLogisticAirportManagement')
        }
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.AirportManagement, status: false }])
      }

      if (this.selectionComponents.selectAirportManagementImport) {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.AirportManagementImport, status: true }])
      } else {
        if (this.transportMode === this.transportModeTypeEnum.aerial && this.journeyDirection === this.directionTypeEnum.import) {
          this.$store.commit('setResetReceptionLogisticsAirportManagement')
        }
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.AirportManagementImport, status: false }])
      }

      if (this.selectionComponents.selectTerminalManagement === true || this.selectionComponents.selectionInternationalTransport === true) {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.InternationalFreight, status: true }])
      } else {
        this.$store.commit('visibleComponents', [{ componentId: ComponentEnum.InternationalFreight, status: false }])
      }
    }

  }
}
</script>

<style scoped>
p {

  margin: 10px;
}
.container{
  padding: 15px 40px;
  margin: 0px !important;
}
.check-label{
  display: inline-flex;
  margin-top: 2px;
  cursor: pointer
}
.title{
  font-weight: 600;
  margin-bottom: 10px;

}
.section-titles{
  width: 85%;
}
.btn{
  padding-right:25px ;
  padding-top: 20px;
}

.title{
  font-weight: bold;
  margin-bottom: 10px;
}
.subtitle{
  margin: 0px 0px 30px 0px;
}
.helper{
  color:rgb(131, 128, 128) !important;
}

@media screen and (max-width: 879px){
  .section-titles{
    width: 100%;
    margin-bottom: 10px;
  }
  .container{
  padding: 15px 40px;
  margin: 0px !important;
}

  .title{
    font-size: 17px;
  }
  .helper{
    font-size: 11px;
    margin-bottom: 15px ;
  }

  *{
    font-size: 12px;
  }

.container{
  padding: 10px 20px;
}
}

@media screen and (max-width: 689px){
  .title{
    font-size: 13px;
  }
  *{
    font-size: 10px;
  }

  .helper{
    font-size: 10px;
  }

}
</style>
